exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__CardLabelValue__valueContainer__l-rBy {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  padding-bottom: 6px;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: start;\n  color: #333;\n}\n\n.dmb-web__CardLabelValue__fillingColumn__2lGx7 {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  border-bottom: 1px dotted #CCC;\n  margin: 13px 8px 0;\n}\n", ""]);

// exports
exports.locals = {
	"valueContainer": "dmb-web__CardLabelValue__valueContainer__l-rBy",
	"fillingColumn": "dmb-web__CardLabelValue__fillingColumn__2lGx7"
};